import { createContext } from "react";

export const InventoryDocContext = createContext({
  inventoryDoc: {},
  onChange: () => {},
});
